import React from "react"
import {useTranslation} from "react-i18next"

import {getCurrentLanguage} from "../../../i18n.ts"
import {
  ASalesAssistantDeal,
  ASalesAssistantNextSteps,
  ASalesAssistantTaskStatuses,
  ASalesAssistantTaskTypes,
} from "../../../services/types.generated"
import {apiDateToJS} from "../../../utils/dateArithmetics.ts"

export const PlannedActivityCell: React.FC<{row: ASalesAssistantDeal}> = ({row}) => {
  const {t} = useTranslation()
  const {planned_task} = row
  const {contact} = row

  if (!planned_task) {
    return "-"
  }

  if (planned_task.status == ASalesAssistantTaskStatuses.Completed) {
    return (
      <>
        <span className={"font-medium"}>
          {(planned_task.next_step &&
            ((planned_task.next_step === ASalesAssistantNextSteps.Email &&
              t("SalesAssistant_Deals_Table_PlannedTask_Preparing_Email")) ||
              (planned_task.next_step === ASalesAssistantNextSteps.Call &&
                t("SalesAssistant_Deals_Table_PlannedTask_Preparing_Call")) ||
              (planned_task.next_step === ASalesAssistantNextSteps.Meeting &&
                t("SalesAssistant_Deals_Table_PlannedTask_Preparing_Meeting")) ||
              (planned_task.next_step === ASalesAssistantNextSteps.Nothing &&
                t("SalesAssistant_Deals_Table_PlannedTask_Preparing_Nothing")) ||
              "-")) ||
            "-"}
        </span>
      </>
    )
  }

  return (
    <div>
      <span className={"mr-1 font-bold"}>
        {(planned_task.type === ASalesAssistantTaskTypes.SalesAssistantTasksEmail &&
          t("SalesAssistant_Deals_Table_PlannedTask_Type_Email")) ||
          (planned_task.type === ASalesAssistantTaskTypes.SalesAssistantTasksCall &&
            t("SalesAssistant_Deals_Table_PlannedTask_Type_Call")) ||
          (planned_task.type === ASalesAssistantTaskTypes.SalesAssistantTasksMeeting &&
            t("SalesAssistant_Deals_Table_PlannedTask_Type_Meeting")) ||
          t("SalesAssistant_Deals_Table_PlannedTask_Type_None")}
      </span>
      <span className={"font-bold text-cr-blue"}>
        {contact && (contact.first_name || contact.last_name)
          ? [contact.first_name, contact.last_name].filter(Boolean).join(" ")
          : "-"}
      </span>
      {planned_task.date && (
        <div className={"mt-0.5 text-xs font-light"}>
          {apiDateToJS(planned_task.date).toLocaleString(getCurrentLanguage(), {
            day: "2-digit",
            month: "long",
            year: "numeric",
          })}
        </div>
      )}
    </div>
  )
}
